/**
 * @generated SignedSource<<2253b7ea689c71705474f6e4c0b83d1d>>
 * @relayHash 6226f89509f8321a79ba2439c58e664a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 055aa5004ed2ea754843161064d07dcd79090a6b8294e4f61b43bda33595ddc8

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraPublishIssueSearchConfigInput = {
  settings?: JiraIssueSearchSettings | null | undefined;
  viewId: string;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchStaticViewInput = {
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  first?: number | null | undefined;
  groupBy?: string | null | undefined;
  input: JiraPublishIssueSearchConfigInput;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  settings?: JiraIssueSearchSettings | null | undefined;
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation$data = {
  readonly jira_publishIssueSearchConfig: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly view: {
      readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonCollapsible">;
    } | null | undefined;
  } | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation = {
  response: SaveResetViewSettingsButtonUIPublishSettingsMutation$data;
  variables: SaveResetViewSettingsButtonUIPublishSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v12 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "success"
},
v14 = {
  "kind": "ScalarField",
  "name": "message"
},
v15 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v16 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = {
  "kind": "Variable",
  "name": "settings",
  "variableName": "settings"
},
v20 = {
  "kind": "ScalarField",
  "name": "jql"
},
v21 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "selections": [
      {
        "args": (v12/*: any*/),
        "concreteType": "JiraPublishIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishIssueSearchConfig",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "SaveResetViewSettingsButtonCollapsible"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Operation",
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "selections": [
      {
        "args": (v12/*: any*/),
        "concreteType": "JiraPublishIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishIssueSearchConfig",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canPublishViewConfig"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                  },
                  {
                    "args": [
                      (v19/*: any*/)
                    ],
                    "kind": "ScalarField",
                    "name": "isViewConfigModified"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                          },
                          (v21/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                          }
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "groupByField",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                  },
                                  (v18/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hideDone"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                          }
                        ]
                      }
                    ],
                    "type": "JiraSpreadsheetView",
                    "abstractKey": "__isJiraSpreadsheetView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                          },
                          {
                            "kind": "Variable",
                            "name": "before",
                            "variableName": "before"
                          },
                          {
                            "kind": "Variable",
                            "name": "fieldSetsInput",
                            "variableName": "fieldSetsInput"
                          },
                          {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                          },
                          (v21/*: any*/),
                          {
                            "kind": "Variable",
                            "name": "last",
                            "variableName": "last"
                          },
                          {
                            "kind": "Variable",
                            "name": "options",
                            "variableName": "options"
                          },
                          {
                            "kind": "Variable",
                            "name": "scope",
                            "variableName": "scope"
                          },
                          (v19/*: any*/)
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraDetailedView"
                  }
                ],
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "055aa5004ed2ea754843161064d07dcd79090a6b8294e4f61b43bda33595ddc8",
    "metadata": {},
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b9d1a6811b59c23a8c0c232ea09798d1";

export default node;
